import React, { FC, memo } from 'react'
import { IExamsListProps } from '../types'
import { ExamsListItem } from './ExamsListItem'
import SC from '../base/ExamsList.styles'

const { Block } = SC

/** Список экзаменов */
const ExamsList: FC<IExamsListProps> = (props) => {
  const { id, items, getLinkProps } = props

  return (
    <Block>
      {items.map((exam, index) => (
        <ExamsListItem id={id} {...exam} key={index} getLinkProps={getLinkProps} />
      ))}
    </Block>
  )
}

export { ExamsList }
export default memo(ExamsList)
